/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as AppBskyVideoDefs from './defs.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'app.bsky.video.getUploadStatus'

export type QueryParams = {
  jobId: string
}
export type InputSchema = undefined

export interface OutputSchema {
  jobId: string
  partSizeBytes: number
  partCount: number
  receivedParts: number[]
  expiresAt: string
  state:
    | 'created'
    | 'finishing'
    | 'completed'
    | 'failed'
    | 'aborted'
    | 'expired'
    | (string & {})
  /** Present only when state is completed; may differ from jobId on deduplication. */
  completedJobId?: string
  jobStatus?: AppBskyVideoDefs.JobStatus
  /** Present only when state is failed. */
  failureReason?: string
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export class UploadNotFoundError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
    if (e.error === 'UploadNotFound') return new UploadNotFoundError(e)
  }

  return e
}
